const Button = ({
  size,
  color,
  colorOpacity,
  link,
  text,
  textColor,
  textColorHex,
  colorHex,
  className,
  download = false,
  target = '_self'
}) => (
  <div className="rounded-full inline-block">
    <a
      href={link}
      target={target}
      className={`flex items-center justify-center rounded-full border border-transparent text-base font-alliance-medium lg:min-w-[250px] ${
        color && !colorHex
          ? `bg-${color} hover:bg-${color}`
          : 'bg-accent hover:bg-[#c9e300]'
      }
      ${colorOpacity ? `bg-opacity-${colorOpacity}` : null}
      ${textColor && !textColorHex ? `text-${textColor}` : 'text-blue'}
      ${
        size === 'small'
          ? ' px-4 py-1 md:py-2 md:px-5 text-[14px] lg:text-[18px]'
          : ' px-16 py-4 md:py-6 md:px-10 text-[18px] lg:text-[24px]'
      }
      ${className}`}
      style={
        (colorHex
          ? {
              backgroundColor: colorHex
            }
          : null,
        textColorHex
          ? {
              color: textColorHex
            }
          : null)
      }
      download={download}
    >
      {text}
    </a>
  </div>
)
// ${
//   size === 'medium'
//     ? ' px-6 py-3 md:py-4 md:px-8 text-[18px] lg:text-[24px]'
//     : null
// }

export default Button
